import React, { useEffect } from "react";
import { ThemeProvider } from "./contexts/ThemeContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import { GlobalStyles } from "./styles/GlobalStyles";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Metrics from "./components/Metrics";
import Problem from "./components/Problem";
import Services from "./components/Services";
import Differentials from "./components/Differentials";
import Testimonials from "./components/Testimonials";
import About from "./components/About";
import Clients from "./components/Clients";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

// Importação de bibliotecas para animações
import AOS from "aos";
import "aos/dist/aos.css";

function App() {
  // Inicializar AOS (Animate On Scroll)
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: false,
      mirror: true,
    });
  }, []);

  return (
    <ThemeProvider>
      <LanguageProvider>
        <GlobalStyles />
        <div className="App">
          <Header />
          <main>
            <Hero />
            <Metrics />
            <Problem />
            <Services />
            <Differentials />
            <Testimonials />
            <About />
            <Clients />
            <Contact />
          </main>
          <Footer />
        </div>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
